module.exports = __webpack_public_path__ + "../resources/img/login_img.3b1f277b.png";